import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { OrderByPipe } from './pipes/orderBy/order-by.pipe';
import { DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NotifierModule, NotifierOptions } from 'angular-notifier';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpTokenInterceptor } from './services/httpTokenInterceptor';
import { LayoutModule } from '@angular/cdk/layout';
import { WebStorageModule } from 'ngx-store';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DeleteConfirmationModalComponent } from './delete-confirmation-modal/delete-confirmation-modal.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { UserIdleModule } from 'angular-user-idle';
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { HomeComponent } from './home/home.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { HeaderComponent, DialogContent, CashRequestDialog } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { LeftNavbarComponent } from './left-navbar/left-navbar.component';
import { SharedAngularModuleModule } from './shared-angular-module/shared-angular-module.module';
import { SessionConfirmationModalComponent } from './session-confirmation-modal/session-confirmation-modal.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { SubscriptionPricingComponent } from './subscription-pricing/subscription-pricing.component';
import { MyPortfolioProComponent } from './my-portfolio-pro/my-portfolio-pro.component';
import { AboutComponent } from './about/about.component';
import { EmailVerificationComponent } from './email-verification/email-verification.component';
import { RestoreAccountComponent } from './restore-account/restore-account.component';
import { CompleteRestoreComponent } from './complete-restore/complete-restore.component';
import { CashWithdrawDepositComponent } from './cash-withdraw-deposit/cash-withdraw-deposit.component';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

/**
 * Custom angular notifier options
 */

const customNotifierOptions: NotifierOptions = {
  position: {
    horizontal: {
      position: 'right',
      distance: 12
    },
    vertical: {
      position: 'top',
      distance: 12,
      gap: 10
    }
  },
  theme: 'material',
  behaviour: {
    autoHide: 5000,
    onClick: 'hide',
    onMouseover: 'pauseAutoHide',
    showDismissButton: true,
    stacking: 4
  },
  animations: {
    enabled: true,
    show: {
      preset: 'slide',
      speed: 300,
      easing: 'ease'
    },
    hide: {
      preset: 'fade',
      speed: 300,
      easing: 'ease',
      offset: 50
    },
    shift: {
      speed: 300,
      easing: 'ease'
    },
    overlap: 150
  }
};

@NgModule({
  declarations: [
    AppComponent,
    OrderByPipe,
    DeleteConfirmationModalComponent,
    SignupComponent,
    LoginComponent,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    LeftNavbarComponent,
    SessionConfirmationModalComponent,
    ForgotPasswordComponent,
    ChangePasswordComponent,
    PageNotFoundComponent,
    SubscriptionPricingComponent,
    MyPortfolioProComponent,
    AboutComponent,
    EmailVerificationComponent,
    DialogContent,
    CashRequestDialog,
    RestoreAccountComponent,
    CompleteRestoreComponent,
    CashWithdrawDepositComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    FontAwesomeModule,
    BrowserAnimationsModule,
    SharedAngularModuleModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NotifierModule.withConfig(customNotifierOptions),
    LayoutModule,
    WebStorageModule,
    NgxSpinnerModule,
    NgxChartsModule,
    UserIdleModule.forRoot({ idle: 1200, timeout: 60, ping: 1 })
  ],
  providers: [DatePipe, OrderByPipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpTokenInterceptor,
      multi: true
    }
  ],
  entryComponents: [DeleteConfirmationModalComponent, SessionConfirmationModalComponent, DialogContent, CashRequestDialog, CashWithdrawDepositComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
